module.exports = __webpack_public_path__ + "static/media/adult_baptism.7b732f9a.jpg";